import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class LogsService {
    constructor(private http: HttpClient) {}

    private static token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJIQUJJTCIsIm5hbWUiOiJLT0lOT05JQSJ9.IiYLFfWgCnKkrQASae42K_ar7DAaew7US4TUVHW3tYg";
    public static setToken(token) {
        this.token = token;
    }

    private get token() {
        return LogsService.token;
    }

    getErrors(start = 0, length = 100, params: any[] = []): Observable<any[]> {
        const url = environment.apiLogs + "/errors?start=" + start + "&length=" + length;
        const h = new HttpHeaders({
            Accept: "application/json; charset=utf-8",
            "auth": this.token,
            "qb": 'true',
            'params': JSON.stringify(params)
        });
        return this.http.get<any[]>(url, { headers: h });
    }

    getImportacoes(start = 0, length = 100, params: any[] = []): Observable<any[]> {
        const url = environment.apiLogs + "/importacao?start=" + start + "&length=" + length;
        const h = new HttpHeaders({
            Accept: "application/json; charset=utf-8",
            "auth": this.token,
            "qb": 'true',
            'params': JSON.stringify(params)
        });
        return this.http.get<any[]>(url, { headers: h });
    }

    private get headersRejeicao() {
        return new HttpHeaders({
            Accept: "application/json; charset=utf-8",
            "auth": this.token,
        });
    }

    getRejeicoesFiscais(start = 0, length = 50, filtros: any = {}): Observable<{ list: any[], total: number, retencaoDias: number }> {
        let params = new HttpParams().set("start", String(start)).set("length", String(length));
        Object.keys(filtros).forEach(k => {
            if (filtros[k] !== null && filtros[k] !== undefined && filtros[k] !== "") {
                params = params.set(k, String(filtros[k]));
            }
        });
        return this.http.get<any>(environment.apiLogs + "/rejeicoes-fiscais", { headers: this.headersRejeicao, params });
    }

    getRejeicaoFiscal(id: number): Observable<any> {
        return this.http.get<any>(environment.apiLogs + "/rejeicoes-fiscais/" + id, { headers: this.headersRejeicao });
    }

    getResumoRejeicoesFiscais(): Observable<{ cStat: number, xStat: string, total: number, clientes: number }[]> {
        return this.http.get<any>(environment.apiLogs + "/rejeicoes-fiscais/resumo", { headers: this.headersRejeicao });
    }

}
